export default __webpack_public_path__ + "static/media/globe.1f65b86f.svg";